module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"seeAs":"Ver como","editGroups":"Gerenciar grupos"},"en":{"seeAs":"See as","editGroups":"Manage groups"}}')
  delete Component.options._Ctor
}
